import colors from "assets/theme/base/colors";

export class SalesBySectorSummaryModel {
  constructor(company, color) {
    this.company = company;
    this.color = color != null ? color : "dark";
    this.sectors = {};
  }
  // Getter
  get total() {
    let total = 0;
    const sectorsKey = Object.keys(this.sectors);
    sectorsKey.forEach((elem) => {
      total = total + this.sectors[elem].sale;
    });

    return total.toFixed(2);
  }
}

export function getSalesDataBySector(data, catalogSectors) {
  // returns a List of SalesSummaryModel
  // returns list<SalesSummaryModel>
  console.log("catalogSectors: ", catalogSectors);
  let companies = [];
  let result = [];
  var color_list = Object.keys(colors.gradients);

  // removing light from list of colors
  const removingLightColor = color_list.indexOf("light");
  if (removingLightColor > -1) {
    color_list.splice(removingLightColor, 1);
  }
  // get all companies
  data.forEach((elem) => {
    if (!companies.includes(elem.companyName)) {
      companies.push(elem.companyName);
    }
  });

  while (color_list.length <= companies.length) {
    color_list.push.apply(color_list, Object.keys(colors.gradients));
  }

  // build SalesSummary per company
  companies.forEach((company, index) => {
    var temp_company = new SalesBySectorSummaryModel(company, color_list[index]);

    catalogSectors.forEach((sector) => {
      temp_company.sectors[String(sector.id)] = { sale: 0, name: sector.name };
    });

    data.forEach((row) => {
      if (company === row.companyName) {
        temp_company.sectors[String(row.sectorId)].sale = row.sale;
      }
    });

    result.push(temp_company);
  });
  result.sort((a, b) => b.total - a.total);
  return result;
}
